import firebase from 'firebase/app'
import 'firebase/database';
const db = firebase.database();
export { db };


// WEBPACK FOOTER //
// ./src/firebase/db.js